import { ScreenManager } from "../../managers/ScreenManager";
import { IconButton } from "../../ui/IconButton";
import { RectSize } from "../../utils/RectSize";
import { LoaderFileKeys } from "../constant/AppConstants";
import { LanguageId } from "../localization/AppLocalization";
import { LayoutDataManager } from "../managers/LayoutDataManager";
import { AppSettings } from "../managers/AppSettings";
import { ScrollableContentScreenBase } from "./ScrollableContentScreenBase";
import { StatisticsContentsScroll } from "./statistics/StatisticsContentsScroll";
import { VariationId } from "./TableScreen";
import { ButtonEvents } from "../../ui/ButtonBase";
import { GTMTracking } from "../managers/GTMTracking";


export class StatisticsScreen
    extends ScrollableContentScreenBase {
    public btnClose: IconButton;
    protected onCloseClick: Function;
    // following 2 vars reflect current component state
    protected curVariationId: VariationId;
    protected curLanguageId: LanguageId;
    /**
     * Forced true on @see StatisticsDtaManager.SaveVariationData
     */
    protected isDirty: boolean;


    public override Init(
        onCloseClick?: Function,
        variationId: VariationId = undefined,
        languageId: LanguageId = undefined,
    ): void {
        // > ApplyMixins (Showable) + SetTweenProps
        super.Init();

        this.onCloseClick = onCloseClick;
        this.curVariationId = variationId;
        this.curLanguageId = languageId;
    }

    public override Build(): void {
        // build subclass objects required by base
        // custom ContentsScrollPane
        // NOTE: add in base
        this.contentsScrollPane = new StatisticsContentsScroll(this.scene);
        (this.contentsScrollPane as StatisticsContentsScroll).Init(
            true,
            LayoutDataManager.GetSharedData().general.scrollableContent.size.innerScale, // referenceWidth
            this.curVariationId,
            this.curLanguageId
        );
        // console.log(VariationId[this.curVariationId], LanguageId[this.curLanguageId]);
        this.contentsScrollPane.Build();

        // build base
        // > bg
        // > (add) contentsScrollPane
        // > btnPrev
        // > btnNext
        // > title
        super.Build();

        // btnClose
        this.btnClose = new IconButton(this.scene);
        this.btnClose.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-round-bg-out.png" }
        });
        this.btnClose.InitIcon({
            out: { texture: LoaderFileKeys.ui, frame: "icon-x-black.png" }
        });
        this.btnClose.PostInit(50);
        // this.btnClose.setData("baseScale", 1.0);
        this.add(this.btnClose);

        // > contentsScrollPane
        // > title (contentsScrollData->capitalizedTitle)
        this.UpdateFromLocalizationChange();
    }

    protected OnShowStart(animated: boolean): void {
        GTMTracking.PLDTrackingMenu("statistics_"+VariationId[this.curVariationId]);
        super.OnShowStart(animated);
    }

    /**
     * Make dirty (forcing rebuild on SetData) due to @see StatisticsDataManager.SaveVariationData
     */
    public SetDirty(): void {
        this.isDirty = true;
    }

    public SetData(
        variationId: VariationId = undefined,
        languageId: LanguageId = undefined,
    ): void {
        // console.log(`SetData variationId=${variationId}(${this.curVariationId}) languageId=${languageId}(${this.curLanguageId})`);

        // was dirty set externally (this.isDirty; due to saving of new table data - need rebuild stats screen)
        let isDirty: boolean = this.isDirty ?? false;
        this.isDirty = false;
        // display stats screen for new variationId
        if (variationId != undefined && this.curVariationId != variationId) {
            this.curVariationId = variationId;
            isDirty = true;
        }
        // display stats screen for new languageId
        if (languageId != undefined && this.curLanguageId != languageId) {
            this.curLanguageId = languageId;
            isDirty = true;
        }
        // if language or variation changed
        // console.log(isDirty);
        if (isDirty) {
            // update view with new LOC texts, reposition.
            (this.contentsScrollPane as StatisticsContentsScroll).SetData(
                this.curVariationId,
                this.curLanguageId,
                // AppLocalization.GetVariationData(this.curVariationId).rules,
                // ThemeDataManager.GetVariationData(this.curVariationId).rules,
            );
            // update scroll data
            this.UpdateFromLocalizationChange();
        }
        // console.log("isDirty?", isDirty);
    }

    protected override RegisterListeners(): void {
        // > btnPrev
        // > btnNext
        // > contentsScrollPane
        // > ScreenManagerEvents.RESIZE
        super.RegisterListeners();

        this.btnClose.on(ButtonEvents.CLICK, this.onCloseClick, this);
    }

    protected override UnregisterListeners(): void {
        super.UnregisterListeners();

        this.btnClose.off(ButtonEvents.CLICK, this.onCloseClick, this);
    }

    protected override OnResize(windowRect: RectSize): void {
        // console.log("OnResize");

        super.OnResize(windowRect);

        // const screenCenterX: number = (0.5 * windowRect.width)|0;
        // const scrollPaneWidth = Math.min(windowRect.width * 0.8, this.maxWidth);
        // const titleScale: number = ApplyScalingBias(scrollPaneWidth / this.maxWidth, 1.0);
        const btnCloseScale = ScreenManager.GetAssetScale(
            LayoutDataManager.GetSharedData().general.screen.closeButton.baseScale,
            LayoutDataManager.GetSharedData().general.screen.closeButton.scaleBias,
        );

        // const btnCloseBaseScale = this.btnClose.getData("baseScale");
        // this.btnClose.scale = btnCloseBaseScale * btnCloseScale;
        this.btnClose.setScale(btnCloseScale);
        this.btnClose.setPosition(windowRect.width * 1.0 - 90 * btnCloseScale, 90 * btnCloseScale);
    }
}